/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_ADMIN_USER: {
    size: 10,
    skip: 0,
    where: [],
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.adminPage.admin.user',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_ADMIN_USER' },
      },
    },
    GET_ADMIN_USER: {
      invoke: {
        id: 'adminUser',
        src: 'adminUser',
        onDone: {
          target: 'RENDER_ADMIN_USER',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_ADMIN_USER_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_ADMIN_USER: {
      on: {
        TRIGGER_REFRESH: {
          target: 'GET_ADMIN_USER',
        },
      },
    },
    RENDER_ADMIN_USER_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
